/*
 * The compiled Aurora bundle's ColorSwatchesPicker writes the hovered colour
 * name into [data-color-swatches-picker-active-value] on mouseenter, and on
 * mouseleave restores the .selected label's data-value. If no .selected label
 * exists at that instant — which happens transiently while Aurora re-renders the
 * variant picker on a colour/variant swap — it writes "" and the label goes
 * blank. The bundle is uneditable, so we guard the label theme-side: whenever it
 * is blanked, restore it from the current .selected swatch, the last known
 * selected value, or the server-rendered initial value (the resting fallback for
 * pickers that have no .selected swatch, e.g. a product absent from its own
 * siblings list). We only ever act on an empty write, so real hovers and normal
 * selections pass through untouched.
 */
(() => {
  const ACTIVE_SELECTOR = '[data-color-swatches-picker-active-value]';
  const LABEL_SELECTOR = '[data-color-swatches-picker-label]';
  const GUARDED = '__cslGuarded';

  const isBlank = (text) => !text || !text.trim();

  const selectedValue = (activeEl) => {
    const picker = activeEl.closest('color-swatches-picker');
    const selected = picker && picker.querySelector(`${LABEL_SELECTOR}.selected`);
    return selected ? selected.getAttribute('data-value') || '' : '';
  };

  const cacheSelected = (activeEl) => {
    const value = selectedValue(activeEl);
    if (value) activeEl.dataset.lastColor = value;
  };

  const restore = (activeEl) => {
    if (!isBlank(activeEl.textContent)) {
      cacheSelected(activeEl);
      return;
    }
    const value = selectedValue(activeEl) || activeEl.dataset.lastColor || '';
    if (value && value !== activeEl.textContent) activeEl.textContent = value;
  };

  const guard = (activeEl) => {
    if (activeEl[GUARDED]) return;
    activeEl[GUARDED] = true;
    cacheSelected(activeEl);
    if (!activeEl.dataset.lastColor && !isBlank(activeEl.textContent)) {
      activeEl.dataset.lastColor = activeEl.textContent.trim();
    }
    restore(activeEl);
    const observer = new MutationObserver(() => restore(activeEl));
    observer.observe(activeEl, { childList: true, characterData: true, subtree: true });
  };

  const scan = (root) => {
    if (root.nodeType !== Node.ELEMENT_NODE) return;
    if (root.matches && root.matches(ACTIVE_SELECTOR)) guard(root);
    if (root.querySelectorAll) root.querySelectorAll(ACTIVE_SELECTOR).forEach(guard);
  };

  const init = () => {
    scan(document.body);
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) scan(node);
      }
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
